var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orders-section"},[_vm._v(" orders section "),_c('OrdersTable',{attrs:{"items":_vm.companyOrders}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }